import { render, staticRenderFns } from "./BussinessRegistration.vue?vue&type=template&id=48d0c146&"
import script from "./BussinessRegistration.vue?vue&type=script&lang=ts&"
export * from "./BussinessRegistration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports